export const fonts = {
  body: `'AvenirNext', Arial, sans-serif`,
  heading: `'AvenirNextCondensed', Arial, sans-serif`
};
